<template>
  <div v-loading.fullscreen.lock="loading" element-loading-text="拼命加载中" element-loading-background="rgba(0, 0, 0, 0.8)" class="registerDiaBOx">
    <el-dialog title=""  @close="clearDia"  @open="diaInit" center :visible.sync="diaShow" width="600px">
      <div class="titleBox">
        <svg class="svg_icon" aria-hidden="true" style="width: 50px; height: 50px">
          <use xlink:href="#iconLOGO"></use>
        </svg>
        <div style="height: 24px;">欢迎注册</div>
      </div>
      <div class="formDataBox">
        <ul class="ulBox">
          <li>
            <div class="liBox specialliBox">
                <el-dropdown @command="handleCommand">
                <div class="inputMiddle">
                  <div style="display:flex;">
                    <div class="liLeftBox">商户类型：</div>
                    <div :class="hotelTypeValue?'specialColor':''">{{hotelTypeValue||'请选择商户类型'}}</div>
                  </div>
                  <svg class="svg_icon svgHover" aria-hidden="true" style="width: 16px; height: 16px;">
                    <use xlink:href="#iconxiala"></use>
                  </svg>
                </div>
                <el-dropdown-menu style="width:310px;text-align:left;top:300px;" slot="dropdown">
                  <el-dropdown-item v-for="(items,index) in typeList" :key="index" :command="index" class="routerStyle">
                    {{items.lable}}
                  </el-dropdown-item>
                  <!-- <el-dropdown-item command="1" class="routerStyle">供货商-单门店酒店民宿 （非集团）</el-dropdown-item>
                  <el-dropdown-item command="3" class="routerStyle">供货商-电商商户 （非集团）</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </li>
          <li class="hotelNameLi">
            <div class='liBox' :class="[{hoverStatusColor:this.inputStatusList[0].hoverStatus},{focusStatusColor:this.inputStatusList[0].focusStatus},{errorStatusColor:this.inputStatusList[0].errorStatus}]" @mouseenter='hoverin(0)' @mouseleave="hoverout(0,$event)">
              <div class="liLeftBox">商户名称：</div>
              <input v-model="hotelCname" class="hotelCname" @focus="inputFocusState(0)" @blur="inputBlurState(0)" placeholder="如你的商户已经注册，请直接登录" type="text">
            </div>
            <div style="color:#B3B3B3;" class="errorMessage" v-if="this.inputStatusList[0].focusStatus&&!this.inputStatusList[0].errorStatus">如你的商户已经注册，请直接登录</div>
            <div v-if="this.inputStatusList[0].errorMessage" class="errorMessage">{{this.inputStatusList[0].errorMessage}}</div>
          </li>
          <li style="border:none">
            <div class='specialLiBox'>
              <div>
                <div class='contactBox' :class="[{hoverStatusColor:this.inputStatusList[1].hoverStatus},{focusStatusColor:this.inputStatusList[1].focusStatus},{errorStatusColor:this.inputStatusList[1].errorStatus}]" @mouseenter='hoverin(1)' @mouseleave="hoverout(1,$event)">
                  <div class='liLeftBox'>联系人：</div>
                  <input v-model="contact" @focus="inputFocusState(1)" @blur="inputBlurState(1)" class="contactInput" placeholder="" type="text">
                </div>
                <div v-if="this.inputStatusList[1].errorMessage" class="errorMessage">{{this.inputStatusList[1].errorMessage}}</div>
              </div>
              <div>
                <div class="contactBox phoneBox" :class="[{hoverStatusColor:this.inputStatusList[2].hoverStatus},{focusStatusColor:this.inputStatusList[2].focusStatus},{errorStatusColor:this.inputStatusList[2].errorStatus}]" @mouseenter='hoverin(2)' @mouseleave="hoverout(2,$event)">
                  <div style="width:50px;" class='liLeftBox'>手机号：</div>
                  <input v-model="phone" @focus="inputFocusState(2)" @blur="inputBlurState(2)" class="phoneInput" placeholder="" type="num">
                </div>
                <div style='margin-left:20px;' v-if="this.inputStatusList[2].errorMessage" class="errorMessage">{{this.inputStatusList[2].errorMessage}}</div>
              </div>
            </div>
          </li>
          <li>
            <div class='liBox' :class="[{hoverStatusColor:this.inputStatusList[3].hoverStatus},{focusStatusColor:this.inputStatusList[3].focusStatus},{errorStatusColor:this.inputStatusList[3].errorStatus}]" @mouseenter='hoverin(3)' @mouseleave="hoverout(3,$event)">
              <div class="liLeftBox">用户名：</div>
              <input autoComplete="new-password" spellcheck="false" v-model="accountNameValue" @focus="inputFocusState(3)" @blur="inputBlurState(3)" class="hotelCname" placeholder="将作为登录账号，由字母、数字，6~18个字符组成" type="search">
            </div>
            <div style="color:#B3B3B3;" class="errorMessage" v-if="this.inputStatusList[3].focusStatus&&!this.inputStatusList[3].errorStatus">将作为登录账号，由字母、数字，6~18个字符组成</div>
            <div v-if="this.inputStatusList[3].errorMessage" class="errorMessage">{{this.inputStatusList[3].errorMessage}}</div>
          </li>
          <li>
            <div class='liBox' :class="[{hoverStatusColor:this.inputStatusList[4].hoverStatus},{focusStatusColor:this.inputStatusList[4].focusStatus},{errorStatusColor:this.inputStatusList[4].errorStatus}]" @mouseenter='hoverin(4)' @mouseleave="hoverout(4,$event)">
              <div class="liLeftBox">密码：</div>
              <div class="passwordBox">
                <input autoComplete="new-password" spellcheck="false" class="passwordInput" @focus="inputFocusState(4)" @blur="inputBlurState(4)" v-model="password" placeholder="由字母、数字，6~18个字符组成" :type="passwordInputType">
                <svg class="passwordIcon" @click="clickPassWord" aria-hidden="true" style="width: 16px; height: 16px;">
                    <use v-if="passwordInputType=='password'" xlink:href="#iconyincangmima"></use>
                    <use v-else xlink:href="#iconxianshimima"></use> 
                </svg>
              </div>
            </div>
            <div style="color:#B3B3B3;" class="errorMessage" v-if="this.inputStatusList[4].focusStatus&&!this.inputStatusList[4].errorStatus">由字母、数字，6~18个字符组成</div>
            <div v-if="this.inputStatusList[4].errorMessage" class="errorMessage">{{this.inputStatusList[4].errorMessage}}</div>
          </li>
          <li>
            <div class='liBox' :class="[{hoverStatusColor:this.inputStatusList[5].hoverStatus},{focusStatusColor:this.inputStatusList[5].focusStatus},{errorStatusColor:this.inputStatusList[5].errorStatus}]" @mouseenter='hoverin(5)' @mouseleave="hoverout(5,$event)">
              <div class="liLeftBox">邀请码：</div>
              <input v-model="inviteCode" @focus="inputFocusState(5)" @blur="inputBlurState(5)" class="hotelCname" placeholder="" type="text">  
            </div>
            <div v-if="this.inputStatusList[5].errorMessage" class="errorMessage">{{this.inputStatusList[5].errorMessage}}</div>
          </li>
        </ul>
        <!-- @mousedown = "clickRegister" -->
        <div class='registerBtn'>注册</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {registerUserHotel} from '@/api/api'
export default {
	data () {
		return {
			diaShow : this.value,
			hotelCname : '',//商户名称
			typeList : [ {
				type : '0',
				lable : '供货商-集团 （多门店商户请选择集团）'
			},{
				type : '1',
				lable : '供货商-单门店酒店民宿 （非集团）'
			},{
				type : '3',
				lable : '供货商-电商商户 （非集团）'
			},{
				type : '11',
				lable : '分销商'
			} ],
			hotelTypeValue : '',
			type : '',//商户类型
			contact : '',
			phone : '',
			accountNameValue : '',
			password : '',
			inviteCode : '',
			inputStatusList : [ {
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			},{
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			},{
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			},{
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			},{
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			},{
				hoverStatus : false,
				focusStatus : false,
				errorStatus : false,
				errorMessage : '',
			} ],//focusStatus
			passwordInputType : 'password',
			loading : false,
		}
	},
	watch : {
		value(val){
			this.$emit('input',val);
			this.diaShow = val;
		},
		diaShow(val){
			this.$emit('input',val)
		}
	},
	props : {
		value : {
			type : Boolean,
			default : false
		},
	},
	methods : {
		handleCommand(index) {
			this.hotelTypeValue = this.typeList[index].lable
			this.type = this.typeList[index].type
		},
		hoverin(index,value){
      console.log(index,value)
			let inputStatusList = this.inputStatusList;
			for(let i in inputStatusList){
				this.inputStatusList[i].hoverStatus = false;
			}
			this.inputStatusList[index].hoverStatus = true;
		},
		hoverout(index,value){
			this.inputStatusList[index].hoverStatus = false;
		},
		inputFocusState(index){
			let inputStatusList = this.inputStatusList;
			this.placeholder = ''
			for(let i in inputStatusList){
				this.inputStatusList[i].focusStatus = false;
			}
			this.inputStatusList[index].focusStatus = true;
		},
    // else if(index == 4){
    //     let reg = /^.{6,18}$/;
    //     let reg2 = /^[A-Za-z0-9]+$/;
		// 		if(!reg.test(this.password)){
		// 			this.inputStatusList[index].errorStatus = true;
		// 			this.inputStatusList[index].errorMessage = '请输入6~18个字符';
		// 			return;
    //     }
    //     if(!reg2.test(this.password)){
		// 			this.inputStatusList[index].errorStatus = true;
		// 			this.inputStatusList[index].errorMessage = '只能输入数字和字母';
		// 			return;
		// 		}
		// 	}
    // 失去焦点
		inputBlurState(index){
			this.inputStatusList[index].focusStatus = false;
			if(index == 3 || index == 4){ //密码
				let reg = /^.{6,18}$/;
				let reg2 = /^[A-Za-z0-9]+$/;
				if(index == 3 && !reg.test(this.accountNameValue) || index == 4 && !reg.test(this.password)){
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '请输入6~18个字符';
					return;
				}
				if(index == 3 && !reg2.test(this.accountNameValue) || index == 4 && !reg2.test(this.password)){
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '只能输入数字和字母';
					return;
				}
			}
			else if(index == 2){
				// let reg = /^1(3|4|5|7|8|9)\d{9}$/;
				let reg = /^[0-9]*$/
				if(!reg.test(this.phone)||!this.phone) {
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '请输入正确的手机号码';
					return;
				}
			}
			else if(index == 5){
				if(!this.inviteCode) {
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '请输入邀请码';
					return;
				}
			}
			else if(index == 0) {
				if(!this.hotelCname){
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '请输入商户名称';
					return;
				}
			}
			else if(index == 1) {
				if(!this.contact) {
					this.inputStatusList[index].errorStatus = true;
					this.inputStatusList[index].errorMessage = '请输入联系人';
					return;
				}
			}
			this.inputStatusList[index].errorStatus = false;
			this.inputStatusList[index].errorMessage = '';
		},
		clickPassWord() {
			if(this.passwordInputType == 'password'){
				this.passwordInputType = 'search'
			}
			else {
				this.passwordInputType = 'password'
			}
		},
		// clickmousedown(event) {
		// 	event.preventDefault()
		// 	console.log(666)
		// },
		clickRegister() {
			if(!this.hotelCname){
				return;
			}
			if(!this.contact) {
				this.inputStatusList[1].errorStatus = true;
				this.inputStatusList[1].errorMessage = '请输入联系人';
				return;
			}
      // let reg = /^1(3|4|5|7|8)\d{9}$/;
			let reg = /^[0-9]*$/;
			if(!reg.test(this.phone)||!this.phone) {
				this.inputStatusList[2].errorStatus = true;
				this.inputStatusList[2].errorMessage = '请输入正确手机号';
				return;
			}
			let reg3 = /^.{6,18}$/;
			let reg2 = /^[A-Za-z0-9]+$/;
			if(!reg3.test(this.accountNameValue) || !reg2.test(this.accountNameValue)){
				return;
			}
			if(!reg3.test(this.password) || !reg2.test(this.password)){
				return;
			}
			if(!this.inviteCode) {
				return;
			}
			if(!this.type){
				this.open3('请选择商户类型！')
				return;
			}
			
			let _p = {
				userHotelInfo : {
					hotelCname : this.hotelCname,
					type : Number(this.type),
					phone : this.phone,
					contact : this.contact,
					accountName : this.accountNameValue,
					password : this.password,
					inviteCode : this.inviteCode,
				}
			} 
			this.loading = true;
			registerUserHotel(_p).then(result => {
				this.loading = false;
				let data = result.data;
				if(data.sc == 0) {
					this.$message({
						message : '账号注册成功',
						customClass : 'customClass',
						type : 'success',
					});
					this.$router.push({
						path : '/transitionPage',
						query : {
							accountName : encodeURIComponent(this.accountNameValue),
							password : encodeURIComponent(this.password),
						}	
					})
				}
				else if(data.sc == 'BASE-1014'){ //邀请码已使用
					console.log(data.errorMsg)
					this.inputStatusList[5].errorStatus = true;
					this.inputStatusList[5].errorMessage = data.errorMsg || '';
				}
				else if(data.sc == 'BASE-1000') { //账号已存在
					this.inputStatusList[3].errorStatus = true;
					this.inputStatusList[3].errorMessage = data.errorMsg || '';
				}
				else if(data.sc == 'BASE-1015') { //商户名已存在
					this.inputStatusList[0].errorStatus = true;
					this.inputStatusList[0].errorMessage = data.errorMsg || '';
				}
				else {
					this.open3(data.errorMsg);
				}
			}).catch(err => {
				this.loading = false;
				console.log(err)
			})
		},
		clearDia() {
			console.log('@pen')
		},
		closeDia(){
			this.$emit('input',false)
		},
		diaInit() {
      console.log('打开')
      this.accountNameValue = '';
			// this.$emit('handelChoose',this.selectedRoomType);
		},
		open2(messages) { 
			this.$message({
				message : messages,
				type : 'success'
			});
		},
		open3(messages) {
			this.$message({
				message : messages,
				type : 'warning'
			});
		},
	},
	mounted(){
		this.diaInit();
	},
}
</script>
<style scoped lang='scss'>
 .titleBox {
   margin: 0 auto;
   font-size:20px;
   font-weight:600;
   color:rgba(72,72,72,1);
   display:flex;
   justify-content: center;
   align-items: center;
   margin-top: -35px;
   div {
     margin-left: 8px;
   }
 }
 .formDataBox {
   ul,li{
    display: block;
    padding: 0;
    margin: 0;
    list-style: none;
  }
  .ulBox {
    padding-left: 95px;
    padding-top: 35px;
    li {
       width: 360px;
       margin-bottom: 20px;
       font-size: 12px;
      .liBox {
        width: 360px;
        height: 40px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgba(233,241,242,1);
        box-sizing: border-box;
      }
      .errorMessage {
        color:rgba(253,125,111,1);
        font-size:12px;
        margin-top: 6px;
      }
      .hoverStatusColor {
        border-bottom-color: #ccc;
      }
      .focusStatusColor {
        border-bottom-color: #ccc;
      }
      .errorStatusColor {
        border-bottom-color: #FD7D6F;
      }
      .specialliBox:hover {
          border-bottom-color: #ccc;
        }
      input {
        border: none !important;
        background:none !important;  
        outline:none;  
        height: 37px;
      }
      input:-internal-autofill-selected {
        background: none;
      }
      .hotelCname {
        width: 280px;
      }
      .liLeftBox {
        width: 60px;
        font-size:12px;
        color:rgba(128,128,128,1);
        margin-right: 10px;
      }
      
      .inputMiddle {
        width: 360px;
        height: 42px;
        font-size:12px;
        color:rgba(204,204,204,1);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;
        box-sizing: border-box;
      }
      .liRightBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 10px;
        width: 300px;
        box-sizing: border-box;
        position: relative;
      }
      .specialColor {
        color:rgba(72,72,72,1);
      }
      input::-moz-placeholder{
        color:rgba(204,204,204,1);
        font-size:12px;
      }
      input::-webkit-input-placeholder{
        color:rgba(204,204,204,1);
        font-size:12px;
      }
      .specialLiBox {
        display: flex;
      }
      .contactBox {
        width: 170px;
        border-bottom: 1px solid rgba(233,241,242,1);
        height: 40px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        input {
          width: 90px;
        }
      }
      .hoverStatusColor {
        border-bottom-color: #ccc;
      }
      .focusStatusColor {
        border-bottom-color: #ccc;
      }
      .errorStatusColor {
        border-bottom-color: #FD7D6F;
      }
      .phoneBox {
        margin-left: 20px;
      }
      .passwordInput {
        width: 250px;
      }
      .passwordBox {
        display: flex;
        align-items: center;
        height: 40px;
        justify-content: space-between;
        .passwordIcon {
          margin-left: 10px;
        }
      }
    }
    
  }
 }
 .routerStyle {
    text-decoration: none;
    outline: none;
    color:rgba(72,72,72,1);
    display: block;
    text-align: left;
  }

  .routerStyle:hover {
    color: #FD7D6F!important;
    background:#FAF5F5;
  }
  .registerBtn{
    padding: 0;
    margin: 0;
    margin: 0 auto;
    margin-bottom: 10px;
    border: none;
    display: block;
    color: #fff;
    line-height: 38px;
    height: 38px;
    font-size: 14px;
    font-weight: bold;
    background:linear-gradient(90deg,rgba(255,141,126,1) 0%,rgba(246,115,101,1) 100%);
    box-shadow:0px 10px 18px 0px rgba(253,125,111,0.1);
    border-radius:22px;
    width: 260px;
    margin-top:40px;
    outline: none;
    text-align: center
  }
  .registerBtn:hover{
    background: #ED6758;
    cursor: pointer;
  }
  // .registerBtn:active{
  //   background: #20aeb0;
  //   box-shadow: 0px 10px 20px rgba(36,187,193,0.12);
  // }
  .passwordIcon {
    fill:#ccc;
  }
  .passwordIcon:hover {
    fill:#FD7D6F;
    cursor: pointer;
  }
  .registerDiaBOx{
    input:-webkit-autofill,
    input:-webkit-autofill:focus,
    input:-webkit-autofill-selected 
    input:-internal-autofill-selected {
          background: #fff !important;
          -webkit-box-shadow: 0 0 0 1000px white inset;
        }
     input {
            border: none !important;
            background:none !important;  
            outline:none;  
          }
      input::-moz-placeholder{
        color:#c0cacc !important;
      }
      input::-webkit-input-placeholder{
        color:#c0cacc !important;
      }
      input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
          -webkit-box-shadow:0 0 0px 1000px white inset;
          background: #fff;
          box-shadow:0 0 0px 1000px white inset;
          outline: none;
      } 
      input[type=text]:focus, input[type=password]:focus, textarea:focus { 
      -webkit-box-shadow: 0 0 0px 1000px white inset;
          border:0;
          box-shadow:0 0 0px 1000px white inset;
          background: #fff;
          outline: none;
      }
  }
  .svgHover {
    fill:#ccc;
  }
  .svgHover:hover {
    fill:#ccc;
  }
</style>
<style>
  .el-dropdown-menu__item:hover{
      background: #FAF5F5!important;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    color: #FD7D6F;
    background: #FAF5F5;
  }
  .hoverColor:hover {
    color: #FD7D6F;
  }
  .el-checkbox {
    color:#484848;
  }
  .el-input__inner {
    color:#484848;
  }
  .el-input__inner:focus{
    border-color: #23B3C1;
  }
</style>


// WEBPACK FOOTER //
// src/components/registerDia.vue